module.exports = __webpack_public_path__ + "static/media/hytte.26f4f3b6.m4a";